
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';

import { ComponentsModule } from './components/components.module';
import { RolesModule } from './pages/roles/roles.module';
import { FuncionalidadesModule } from './pages/funcionalidades/funcionalidades.module';
import { UsuariosModule } from './pages/usuarios/usuarios.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { PrincipalComponent } from './pages/principal/principal.component';
import { InterceptorService } from './interceptors/interceptor.service';
import { SharedModule } from './pages/shared.module';
import {  HashLocationStrategy, LocationStrategy } from "@angular/common";
import {InteractionType, IPublicClientApplication, PublicClientApplication} from "@azure/msal-browser";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalService
} from "@azure/msal-angular";
import { msalConfig } from './auth-config';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PrincipalComponent,
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    RolesModule,
    FuncionalidadesModule,
    UsuariosModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule, // Importar SharedModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
